export default {
  common: {
    analyze: "Analyze",
    compare: "Compare",
    search: "Search",
    close: "Close",
    cancel: "Cancel",
    add: "Add",
    save: "Save",
    share: "Share",
    home: "Home",
    back: "Back",
    loading: "Loading...",
    error: "Error",
    noData: "No data",
    years: "{{count}} years",
    score: "{{score}} pts",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    language: "Language",
  },
  home: {
    title: "FINScore\nAI Stock Analysis",
    subtitle: "Automated 6-category analysis based on DART disclosure data\nto evaluate long-term investment suitability",
    searchPlaceholder: "Enter company name (e.g., Samsung Electronics)",
    recentAnalysis: "Recent Analysis",
    compareStart: "Start Compare",
    addCompany: "Add Company",
    tags: {
      valuation: "PER/PBR Valuation",
      profitability: "ROE/ROA Profitability",
      growth: "Revenue Growth",
      stability: "Debt Stability",
      dividend: "Dividend Analysis",
    },
  },
  analyze: {
    searchOther: "Search another company",
    companyOverview: "Company Overview",
    stock: "Stock",
    codeMarket: "Code / Market",
    currentPrice: "Current Price",
    marketCap: "Market Cap",
    dividendCycle: "Dividend Cycle",
    financialSummary: "Financial Summary",
    investmentRatios: "Key Investment Ratios",
    investmentRatiosDesc: "PER shows how many times the stock price is relative to earnings. PBR compares price to book value. ROE measures return on equity. Generally, lower PER/PBR and higher ROE indicate better value.",
    categoryAnalysis: "Category Analysis",
    categoryDesc: "Evaluated on a 100-point scale across 6 categories: Valuation (fair price), Profitability (earnings power), Growth (revenue trend), Stability (debt level), Dividend (shareholder returns), and Cash Flow (actual cash generation). 70+ is strong, 45+ is average, below 45 needs caution.",
    trendAnalysis: "Trend Analysis",
    investmentOpinion: "Investment Opinion",
    aiComment: "AI Investment Comment",
    realtimeValuation: "Realtime Valuation",
    realtimeDesc: "Is the current price cheap or expensive?",
    realtimeExplain: "PER shows price relative to earnings, PBR relative to assets. Compared against historical median to assess current price level. Lower values suggest relative undervaluation.",
    industryPeers: "Industry Peers",
    industryPeersDesc: "Listed companies in the same industry. Click to analyze.",
    disclaimer: "This analysis is based on historical financial data and is for reference only, not investment advice.",
    aiDisclaimer: "AI-generated analysis opinion, not investment recommendation.",
  },
  compare: {
    title: "Stock Comparison",
    close: "End Comparison",
    desc: "Comparing based on financial data from the same period. Best-performing company is highlighted in each metric.",
    scoreCompare: "Score Comparison",
    categoryCompare: "Category Score Comparison",
    keyMetrics: "Key Metrics Comparison",
    financialCompare: "Financial Summary Comparison",
    ratioCompare: "Investment Ratio Comparison",
    trendCompare: "Trend Comparison",
    opinionCompare: "Investment Opinion Comparison",
    aiCompare: "AI Comment Comparison",
    valuationCompare: "Realtime Valuation Comparison",
    duplicateError: "Duplicate company entered.",
  },
  share: {
    kakao: "KakaoTalk",
    nativeShare: "Share",
    copyLink: "Copy Link",
    copied: "Copied!",
    saveImage: "Save Image",
    saving: "Saving...",
    linkCopied: "Link copied to clipboard.",
    imageSaved: "Image saved.",
    imageFailed: "Failed to save image.",
  },
  notFound: {
    title: "Page Not Found",
    desc: "The page you requested does not exist or has been moved.",
    goHome: "Go to Home",
  },
  footer: {
    disclaimer: "This service provides automated analysis based on historical financial data and should be used as reference only.",
  },
  valuation: {
    undervalued: "Undervalued",
    fair: "Fair",
    overvalued: "Overvalued",
    medianPER: "Historical Median",
    realtimePER: "Realtime PER",
    realtimePBR: "Realtime PBR",
  },
  categories: {
    valuation: "Valuation",
    profitability: "Profitability",
    growth: "Growth",
    stability: "Stability",
    dividend: "Dividend",
  },
};
